import {useGetCurrentWorkspaceId} from "@tinct/core-workspace";
import {UpdateVisualIdentityForm} from "../../../forms/update-visual-identity-form";

export const EditBrandVisualIdentityTab = () => {

  const workspaceId = useGetCurrentWorkspaceId();

  return <UpdateVisualIdentityForm organizationId={workspaceId} />
}
